import React from 'react';
import {endOfMonth, endOfWeek, isSameDay, isSameMonth, startOfMonth, startOfWeek} from "date-fns";
import moment from "moment";
import Grid from "@mui/material/Grid";
import {Avatar, Card, CardActionArea, CardContent, CardHeader, Chip, Tooltip,} from "@mui/material";
import clsx from "clsx";
import {addDays} from "../../../../../utils/GenericUtils";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import itLocale from "date-fns/locale/it";
import {amber, blue, brown, green, red} from "@mui/material/colors";
import { Skeleton } from '@mui/material';

const ScadenziarioCell = ({currentMonth, selectedDate, tamponiState, onDateClick, isLoading}) => {
	const classes = BaseStyle();
	const monthStart = startOfMonth(currentMonth);
	const monthEnd = endOfMonth(monthStart);
	const startDate = startOfWeek(monthStart, {
		locale: itLocale
	});
	const endDate = endOfWeek(monthEnd, {
		locale: itLocale
	});
	
	const rows = [];
	let days = [];
	let day = startDate;
	day.setHours(0);
	day.setMinutes(0);
	day.setSeconds(0);
	day.setMilliseconds(0);
	let formattedDate = "";
	let key = 1234;
	
	while (day <= endDate) {
		for (let i = 0; i < 7; i++) {
			formattedDate = moment(day).format("D");
			const cloneDay = day;
			days.push(
				<Grid item xs key={day.toLocaleDateString()} style={
					!isSameMonth(day, monthStart) ? {color: "#939393"} :
						isSameDay(day, selectedDate) ? {color: "#0ff"} : {}}
				>
					{
						isLoading ?
							<Skeleton style={{height: 100}}/> :
							<Card variant={"outlined"}
							      style={isSameDay(new Date(), day) ? {borderColor: "#0097ff"} : {}}
							      className={clsx(classes.roundBorder, isSameDay(day, selectedDate) ? classes.selectedDay : "", !isSameMonth(day, monthStart) ? classes.disabledDay : "")}>
								<CardActionArea disabled={!isSameMonth(day, monthStart)}
								                onClick={() => onDateClick(new Date(cloneDay))}>
									<CardHeader style={{paddingBottom: 0}}
									            title={!isSameMonth(day, monthStart) ? formattedDate :
										            <b style={isSameDay(new Date(), day) ? {
											            color: "#004977",
										            } : {}}>{formattedDate}</b>}/>
									<CardContent className={classes.flexStart} style={{height: 96, alignContent: "flex-end"}}>
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Tamponi da gestire"}>
												<Chip avatar={<Avatar style={{backgroundColor: amber[700], color: "#FFF"}}>DG</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: amber[500], color: "#FFF"}}
												      label={checkIfExistOrZero(tamponiState.tamponiMonth?.["dg"]?.[new Date(day)])}/></Tooltip>}
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Tamponi gestiti da operatori"}>
												<Chip avatar={<Avatar style={{backgroundColor: green[800], color: "#FFF"}}>GG</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: green[600], color: "#FFF"}}
												      label={checkIfExistOrZero(tamponiState.tamponiMonth?.["gg"]?.[new Date(day)])}/>
											</Tooltip>}
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Tamponi gestiti da cittadino"}>
												<Chip avatar={<Avatar style={{backgroundColor: blue[800], color: "#FFF"}}>CC</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: blue[600], color: "#FFF"}}
												      label={checkIfExistOrZero(tamponiState.tamponiMonth?.["cc"]?.[new Date(day)])}/>
											</Tooltip>}
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Tamponi presi in carico"}>
												<Chip avatar={<Avatar style={{backgroundColor: brown[800], color: "#FFF"}}>PR</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: brown[600], color: "#FFF"}}
												      label={checkIfExistOrZero(tamponiState.tamponiMonth?.["pr"]?.[new Date(day)])}/>
											</Tooltip>}
										
										{!isLoading && isSameMonth(day, monthStart) &&
											<Tooltip
												title={"Tamponi di soggetti irreperibili"}>
												<Chip avatar={<Avatar style={{backgroundColor: red[800], color: "#FFF"}}>II</Avatar>}
												      style={{margin: 1, fontSize: 11, backgroundColor: red[600], color: "#FFF"}}
												      label={checkIfExistOrZero(tamponiState.tamponiMonth?.["ii"]?.[new Date(day)])}/></Tooltip>}
									
									</CardContent>
								</CardActionArea>
							</Card>}
				</Grid>
			);
			day = addDays(day, 1)
		}
		rows.push(
			<Grid item xs={12} key={key}>
				<Grid container spacing={3}>
					{days}
				</Grid>
			</Grid>
		)
		key += 1;
		days = [];
	}
	
	return (
		<React.Fragment>
			<Grid container spacing={3}>
				{rows}
			</Grid>
		</React.Fragment>
	);
};

function checkIfExistOrZero(data) {
	return data ? data : 0;
}

export default React.memo(ScadenziarioCell)
